(function() {
  angular.module('benefits')
  .controller('dhmoModalController', ['$uibModalInstance',  '$uibModal', '$scope', '$filter','policy', 'member','$translate',
    function($uibModalInstance, $uibModal, $scope, $filter, policy, member, $translate) {
      var vm = this;
      vm.policy = policy;
      vm.member = member;
      vm.dhmoContactInfo = "";
      vm.close = function() {
        $uibModalInstance.dismiss();
      };
      $translate('content.benefits.dhmoContactInfo.' + vm.policy.groupNumber).then((result) => {
        return result;
      }, () => {
        return $translate('content.benefits.dhmoContactInfo.default');
      }).then((result) => {
        vm.dhmoContactInfo = result;
      });
    }]);
})();
